import { FontColorsOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Card, Col, ColorPicker, Form, Input, Modal, Row, Space, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { API_PREFIX } from '../config';
import { getCurrentUser } from '../services/User';
import { Get, Post } from '../utils/request';

const layout = {
    labelCol: {
        span: 4,
    },
    wrapperCol: {
        span: 18,
    },
};


const Screen = () => {
    const [form] = Form.useForm();
    const [data, setData] = useState<any>([])
    const [current,setCurrent] = useState<any>(null)
    const [isOpen, setIsOpen] = useState<boolean>(false)

const uploadProps = {
    name: 'file',
    multiple: false,
    ignore_files: 0,
    action: `${API_PREFIX}/screen/upload?num=${current?current.num:0}`,
    showUploadList: true,

    headers: {
        "x-auth-token": getCurrentUser().token,
    },
    onChange(info: any) {
        if (info.file.status == "done") {
            const messageCnt = {
                title: '提示',
                centered: true,
                content: (
                    <div>
                        <p>背景图片上传成功</p>
                    </div>
                ),

                onOk() { },
            }
            if (info.file.response.code == 200)
                Modal.info(messageCnt);
            else
                Modal.warn(messageCnt);
            // message.success(info.file.response.message);
        }

    }
};
    const update = () => {
        Get(`/screen`, null).then((v) => {
            // const data = v.data;
            console.log("data", v)
            // {screen_}
            const screens = []
            for (let i = 1; i <= 6; i++) {
                let server = v.data[0]["screen_" + i + "_server"]
                server = server == null ? "" : server
                let wh = v.data[0]["screen_" + i + "_wh"]
                wh = wh == null ? "" : wh
                let title = v.data[0]["screen_" + i + "_title"]
                title = title == null ? "" : title
                
                let fontColor = v.data[0]["screen_" + i + "_fontColor"]
                fontColor = fontColor == null?"#ffffff":fontColor

                let fontSize = v.data[0]["screen_" + i + "_fontSize"]
                fontSize = fontSize == null?"12":fontSize
                screens.push({
                    server, wh, title, num: i,fontColor,fontSize
                })
            }
            form.setFieldsValue(v.data[0])
            setData(screens)

        }).catch((e) => {
            console.log("error", e)
        });

    }
    useEffect(() => {
        update()

    }, [])

    const saveForm = () => {
        form.validateFields().then(() => {
            const formData = form.getFieldsValue();
            formData.num =  current.num
            formData.fontColor = current.fontColor
            Post(`/screen`, {}, formData).then((v) => {

                if (v.code == 0) {
                    Modal.info({
                        title: "提示",
                        content: "标题已经正确设置!"
                    })
                } else {
                    Modal.error({
                        title: "警告",
                        content: "标题设置失败(" + v.message + ")"
                    })
                }
                update()
            })
        }).catch((e) => {

        })


    }

    const setting = (num: number) => {
        return () => {
            setIsOpen(true)
            setCurrent(data[num])
            form.setFieldsValue(data[num])
        }
    }


    return <div style={{ margin: 0 }}>
        <h2 className='title'>标题屏管理</h2>
        <Space direction="horizontal" size={32} wrap={true}>
            {data.map((v: any, idx: number) => {
                return <Card title={`#${idx+1} 标题屏`} style={{ width: 480,height:280 }}>
                    <p>
                        服务器:{v.server}
                    </p>
                    <p>
                        宽/高:{v.wh}
                    </p>
                    <p>
                        标题:{v.title}
                    </p>
                    <Button type="primary" onClick={setting(idx)}>设置</Button>
                </Card>
            })}



        </Space>
        <Modal open={isOpen} okText={"确定"} cancelText="取消" onOk={saveForm} onCancel={() => setIsOpen(false)}>
            <Form
                {...layout}
                name="basic"
                form={form}
            >
                <Form.Item
                    label="服务器"
                    initialValue={"http://admin:console@192.168.42.129/api/program/singleline_scroll.vsn"}
                    name="server"
                    rules={[
                        {
                            required: true,
                            message: '服务器不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="宽x高"
                    name="wh"

                    rules={[
                        {
                            required: true,
                            message: '宽/高不能为空!',
                        },{
                            pattern:/\d+x\d+/,
                            message : "格式不正确,例如 200x100"
                        }

                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="字体大小"
                    name="fontSize"
                    initialValue={12}
                    rules={[
                        {
                            required: true,
                            message: '字体大小不能为空!',
                        }

                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="字体颜色"
                    name="fontColor"
                    initialValue={"#000000"}
                    
                >
                    <ColorPicker onChange={(v)=>setCurrent({...current,fontColor:v.toHexString()})}/>
                </Form.Item>
                <Form.Item
                    label="背景图片"
                    name="bg"

                >
                    <Upload {...uploadProps}>
                        <Button icon={<UploadOutlined />}>上传背景</Button>
                    </Upload>
                </Form.Item>
                <Form.Item
                    label="标题名称"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: '标题名称不能为空!',
                        },
                    ]}
                >
                    <Input.TextArea rows={5} />
                </Form.Item>

            </Form>
        </Modal>

    </div>

};

export default Screen;